import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Tooltip,
  Typography,
} from "antd";
import {  useHistory, useLocation } from "react-router-dom";
import API_SERVICE from "shared/services/api-service";
import { ReactComponent as IconEditBorder} from "../../assets/images/edit_border.svg";
import { ReactComponent as IconEye} from "../../assets/images/eye_border.svg";
import "./index.scss";
import { setScreenHeader } from "shared/redux/common-reducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import { getEnumValue } from "shared/services/Utility";

const { Option } = Select;
const { Title, Text } = Typography;

type Props = {};

const EditLender: React.FunctionComponent<Props> = () => {
  const history = useHistory();
  const location = useLocation() as any;
  const { lenderData } = location.state;
  const [pIDetailList, setPIDetailList] = useState([] as any);
  const [pIDetailInitialValuesForBulk, setPIDetailInitialValuesForBulk] = useState([] as any);
  const [hubList, setHubList] = useState([] as any);
  const [products, setProducts] = useState([] as any);
  const [apiPropertyList, setApiPropertylist] = useState([]) as any
  const [aggregatorList, setAggregatorList] = useState([]) as any
  const [showDSAIdView, setShowDSAIdView] = useState(false);
  const [individualCaseRouting, setIndividualCaseRouting] = useState(false);
  const [bulkCaseRouting, setBulkCaseRouting] = useState(false);
  const [routingMode, setRoutingMode] = useState("Automation");
  const [routingModeBulk, setRoutingModeBulk] = useState("API");
  const [selectedLoanProduct, setSelectedLoanProduct] = useState(undefined);
  const [selectedProductPlan,setSelectedProductPlan] = useState<any>({})
  const [consentRequired, setConsentRequired] = useState(lenderData?.consentRequired)
  const [consentType, setConsentType]=useState('') as any;
  const [selectedLoanProductId, setSelectedLoanProductId] = useState<any>(undefined);
  const [productPlan, setProductPlan]=useState([] as any)
  const [addLenderForm] = Form.useForm() as any;
  const [selectedAggregator, setSelectedAggregator] = useState("")
  const {appColors}: any = useSelector((state: RootState) => state.common);
  const dispatch = useDispatch();
  const [editType, setEditType] = useState<"" | "PRODUCT" | "PLAN" | "PLAN_ADD">("");
  const [isViewPlan, setIsViewPlan] = useState(false);
  const [viewLenderData, setViewLenderData] = useState({}as any)
  const [status, setStatus] = useState(false)
  

  useEffect(() => {
    dispatch(
      setScreenHeader({
        backScreenTitle: "Lender",
        backScreenPath: "/lenders",
        screenTitle: "Edit Lender",
      })
    );
    getProductPlanList(lenderData?.productId[0])
    const indi = lenderData?.routingConfigurationSet?.find((data: any) => data?.routingType == "INDIVIDUAL")
    const bulk = lenderData?.routingConfigurationSet?.find((data: any) => data?.routingType == "BULK")
    addLenderForm.setFieldsValue({
      bankName: lenderData.lenderName,
      product: lenderData?.productId[0],
      productName:lenderData?.products[0],
      status: lenderData?.active,
      consentRequired:lenderData?.consentRequired,
      consentType:lenderData?.consentType,
      individualCaseRouting: indi?.status == "ACTIVE",
      routingMode: indi?.submissionType,
      hub: indi?.hub,
      pincode: indi?.pincode,
      city: indi?.city,
      lenderLoginUrl:indi?.lenderLoginUrl,
      bulkCaseRouting: bulk?.status == "ACTIVE",
      routingMode_bulk: bulk?.submissionType ?? "LOGIN",
      hub_bulk: bulk?.hub,
      pincode_bulk: bulk?.pincode,
      city_bulk: bulk?.city,
      preferenceOrder:lenderData?.preferenceOrder,
      lenderLoginUrl_bulk: bulk?.lenderLoginUrl,
    });
    if (lenderData?.products[0]==="Credit Card"){
      products?.forEach((item, index) => {
        addLenderForm.setFieldsValue({
          [`apiProperty${index}`]: item?.loanProductName
        });
      });
    }
    setIndividualCaseRouting(indi?.status == "ACTIVE")
    setBulkCaseRouting(bulk?.status == "ACTIVE")
    setRoutingMode(indi?.submissionType)
    setRoutingModeBulk(bulk?.submissionType ?? "LOGIN")
    setConsentType(lenderData?.consentType)
    getFiList();
    setViewLenderData(lenderData?.productPlanDetails)
  }, []);

  const addLender = (values: any) => {
    if(!individualCaseRouting && !bulkCaseRouting) {
      notification.error({message:"Please select at lease 1 Case Routing"})
      return;
    }

    if (routingMode == "API" && lenderData?.products[0] !== "Credit Card") {
       updatePartnerIdentificationDetails(values);
    } else {
      updateLenderHandler(values);
    }
  };

  const updateLenderHandler = (values: any) => {
    const indi = lenderData?.routingConfigurationSet?.find((data: any) => data?.routingType == "INDIVIDUAL")
    const bulk = lenderData?.routingConfigurationSet?.find((data: any) => data?.routingType == "BULK")
    const routingConfigurationSet: any = [];
    let aggregatorConfigId = null
    const productPlanDetails: any = editType == "PLAN_ADD" ? lenderData?.productPlanDetails : []
    if(individualCaseRouting || Object.keys(indi ?? {}).length > 0) {
      routingConfigurationSet.push({
        routingType: "INDIVIDUAL",
        status: individualCaseRouting ? "ACTIVE" : "INACTIVE",
        hub: values?.hub ?? indi?.hub,
        pincode: values?.pincode ?? indi?.pincode,
        city: values?.city ?? indi?.city,
        lenderLoginUrl:values?.lenderLoginUrl ?? indi?.lenderLoginUrl,
        submissionType: routingMode,
      });
    }
    if(bulkCaseRouting || Object.keys(bulk ?? {}).length > 0) {

      const keys = Object.keys(values);
      const filterDataObject = keys
        .filter((key) => key.endsWith("_bulk") && key !== "routingMode_bulk")
        .map((key) => ({
          key: key.replace("_bulk", ""),
          value: values[key],
        }));

      routingConfigurationSet.push({
        routingType: "BULK",
        status: bulkCaseRouting ? "ACTIVE" : "INACTIVE",
        hub: values?.hub_bulk ?? bulk?.hub,
        pincode: values?.pincode_bulk ?? bulk?.pincode,
        city: values?.city_bulk ?? bulk?.city,
        lenderLoginUrl:values?.lenderLoginUrl_bulk ?? bulk?.lenderLoginUrl,
        submissionType: routingModeBulk,
        partnerIdentificationDetails: filterDataObject,
      });
    }
    if(values?.productPlanId) {
      productPlanDetails.push({
        productPlanId: values?.productPlanId,
        status: values?.status ? "ACTIVE" :"INACTIVE"
      })
    }
    if(values?.routingMode === "API" || routingMode ==="API") {
        aggregatorConfigId = (values?.aggregator!="oneflo") && (editType == "PLAN_ADD" || editType == "PLAN" || editType == "PRODUCT") //|| ((values?.aggregator?.length ?? 0) != 0)
    ? values?.aggregator ?? lenderData?.aggregatorConfigId
    : null
    }
    const payload = {
      active            : values.status,
      consentType       : (consentType==="Noconsent"?null:consentType),
      consentRequired   : consentRequired,
      dsaCode           : lenderData.dsaCode,
      finInfoId         : lenderData.lenderInfoId,
      name              : lenderData.lenderName,//values.bankName,
      productId         : lenderData?.productId[0],
      products          : [lenderData?.products[0]],
      routingConfigurationSet: routingConfigurationSet,
      aggregatorConfigId:   aggregatorConfigId,
      productPlanDetails:productPlanDetails,
      preferenceOrder:values?.preferenceOrder === undefined ? lenderData?.preferenceOrder : values?.preferenceOrder
    };
    API_SERVICE.updateLender(payload, lenderData.lenderMappingId)
      .then(({ data }) => {
        if (data) {
          if (data.message) {
            notification.success({ message: data.message });
            history.goBack();
          }
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const getFiList = () => {
    API_SERVICE.getFiList({ pageSize: 500, financierCategory:"LENDER" }).then(({ data }) => {
      if (data?.payload?.content) {
        let filterResult = data?.payload?.content?.find((result) => {
          return result?.fiId === lenderData?.lenderInfoId;
        });
        setProducts(filterResult?.lenderLoanDefinition?.allLoanTypes);
        let tmp = filterResult?.lenderLoanDefinition?.allLoanTypes?.map((item)=>({
            id : item?.loanProductId,
            // value : item?.loanProductName
        }))
        setApiPropertylist(tmp)
        setHubList(filterResult?.hubDetails);
      }
    });
  };

  const updatePartnerIdentificationDetails = (values) => {
    const keys = Object.keys(values);
    const filterDataObject = [] as any;

    pIDetailList?.map((data) => {
      let filterData = keys.filter((item) => item === data?.key);
      filterDataObject.push({
        key: filterData[0],
        value: values[filterData[0]],
      });
    });

    const params = {
      lenderId: lenderData.lenderInfoId,
      productIds: [selectedLoanProductId],
      partnerIdentificationKeyDetail: {
        partnerIdentificationDetails: filterDataObject,
      },
      productPlan            :  values?.productPlan,
      aggregator              : values?.aggregator,
      apiPropertyList         : apiPropertyList
    };
    API_SERVICE.updatePartnerIdentificationDetails(
      lenderData.lenderInfoId,
      params
    ).then(({ data }) => {
      updateLenderHandler(values);
    })
    .catch((e: any) => {
      notification.error({ message: API_SERVICE.handleErrors(e) });
    });
  };

  const getPartnerIdentificationDetails = async (lenderId, loanProductId) => {
    try{

    const partnerIdentificationDetails = await API_SERVICE.getPartnerIdentificationDetails(
      lenderId,
      loanProductId
    );
    const bulkCaseRoutingApiData = await API_SERVICE.getBulkCasePartnerIdentificationDetails(lenderData.lenderMappingId);
    
    if (partnerIdentificationDetails?.data?.payload?.partnerIdentificationDetails) {
      setPIDetailList(partnerIdentificationDetails.data.payload.partnerIdentificationDetails);
    }
      const bulkRoutingConfig = bulkCaseRoutingApiData?.data?.payload?.routingConfigurationSet?.find(
        (config: any) => config.routingType === "BULK"
      );
      setPIDetailInitialValuesForBulk(bulkRoutingConfig?.partnerIdentificationDetails);
    } catch(e) {
      console.log("bulkCaseRoutingApiData Error: ", e);
    }
    
  };

  const changeProductHandler = (value: any) => {
    const productFiltered = products?.filter(
      (item) => item.loanProductId == value
    );
    if ((productFiltered?.length ?? 0) > 0) {
      setSelectedLoanProductId(productFiltered[0].loanProductId);
      setSelectedLoanProduct(productFiltered[0].loanProductName);
      getPartnerIdentificationDetails(
        lenderData?.lenderInfoId,
        productFiltered[0]?.loanProductId
      );
    }
  };

  const changeHubHandler = (value: any, isBulkCase: boolean) => {
    let selectedHub = hubList.find((item) => item.hubName == value);
    if(isBulkCase) {
      addLenderForm.setFieldsValue({
        pincode_bulk: selectedHub?.pincode ?? selectedHub?.pinCode,
      });
    } else {
      addLenderForm.setFieldsValue({
        pincode: selectedHub?.pincode ?? selectedHub?.pinCode,
      });
    }
  };

  const columns = [
    {
      title: "Product Name",
      key: "product",
    },
    {
      title: "Routing Mode",
      key: "submissionType",
      render: (_: any, record: any) => {
        return lenderData?.routingConfigurationSet?.map((data: any) => {
          return (
            <div>{`${getEnumValue("ROUTING_TYPE", data?.routingType)} - ${getEnumValue("LENDER_SUBMIT_TYPE", data?.submissionType)}`}</div>
          );
        });
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <Space className="action-button" size="middle">
          <Button
            className="custome-btn-icon-secondary"
            style={{ "--bgColor": appColors?.appSecondaryColor ?? "" } as any}
            size="small"
            type="text"
            icon={<IconEditBorder />}
            onClick={() => {
              setEditType("PRODUCT")
              setIsViewPlan(false)
              setShowDSAIdView(true);
              setSelectedLoanProductId(lenderData?.productId[0]);
              setSelectedLoanProduct(lenderData?.products[0]);
              setStatus(lenderData?.active)
              const bulk = lenderData?.routingConfigurationSet?.find((data: any) => data?.routingType == "BULK")
              if (lenderData?.submissionType === "API" || bulk?.submissionType === "API") {
                getPartnerIdentificationDetails(
                  lenderData?.lenderInfoId,
                  lenderData?.productId[0]
                );
              }
              if(lenderData?.products[0] === "Credit Card") {
                getAggregators(lenderData?.products[0])
                addLenderForm.setFieldsValue({
                  productPlanId: lenderData?.productPlanDetails?.at(0)?.productPlanId,
                  aggregator: lenderData?.aggregatorConfigId === null ? "oneflo" : lenderData?.aggregatorConfigId,
                  preferenceOrder:lenderData?.preferenceOrder
                });
                setSelectedAggregator(lenderData?.aggregatorConfigId === null ? "oneflo" : lenderData?.aggregatorConfigId,)
              }
            }}
          />
          <Tooltip title="View product plan">
            <Button
              className="custome-btn-icon-secondary"
              style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
              size="small"
              type="text"
              icon={<IconEye />}
              onClick={() => {
                setShowDSAIdView(false);
                setIsViewPlan(true)
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const columnsPlan = [
    {
      title: "Product Plan Name",
      dataIndex: "productPlanId",
      key: "activeProductPlans",
      render: (_: any, record: any) => {
        let planName = productPlan.find((item)=>item?.productPlanId === record?.productPlanId)
        return(
             <div>
            {planName?.productPlanName}
          </div>
          
        )
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <Space className="action-button" size="middle">
          <Button
            className="custome-btn-icon-secondary"
            style={{ "--bgColor": appColors?.appSecondaryColor ?? "" } as any}
            size="small"
            type="text"
            icon={<IconEditBorder />}
            onClick={() => {
              setEditType("PLAN")
              setShowDSAIdView(true);
              setSelectedLoanProductId(lenderData?.productId[0]);
              setSelectedLoanProduct(lenderData?.products[0]);
              setSelectedProductPlan(record)
              setStatus(record?.status == "ACTIVE")
              addLenderForm.setFieldsValue({
                  productPlanId: record?.productPlanId,
              });
            }}
          />
        </Space>
      ),
    },
  ];

  
  const changeAggregatorHandler =  (value: any) => {
    setSelectedAggregator(value);   
};

  const btnRadioStyles: any = { '--borderColor': appColors?.appPrimaryColor ?? "" };
  const btnPrimaryStyles : any = {'--btnColor' :appColors?.appPrimaryColor ?? ""};

  const renderIndividualCaseRouting = (isBulkCase: boolean) => {
    return <>
        <Form.Item
          name={`routingMode${isBulkCase?"_bulk":""}`}
          style={{ marginTop: "5px", marginLeft:'20px' }}
        >
          <Radio.Group
            className="dynamic-radio d-flex-column"
            style={btnRadioStyles}
            onChange={(e) =>{
              if(isBulkCase) {
                setRoutingModeBulk(e?.target?.value)
              } else {
                setRoutingMode(e?.target?.value)
              }
              // setConsentType(e?.target?.value==="API"?"GLOBAL":(lenderData?.consentType))
              // addLenderForm.setFieldsValue({
              //   consentType:(e?.target?.value==="API"?"GLOBAL":(lenderData?.consentType))
              // });
            }
            }
            name={`routingMode${isBulkCase?"_bulk":""}`}
          >
            <Radio value={"API"}>API</Radio>
            {!isBulkCase && 
              <Radio value={"AUTOMATION"} checked>
                Automation
              </Radio>
            }
            <Radio value={"LOGIN"}>Login</Radio>
            {!isBulkCase && 
              <Radio value={"WEBLINK"}>Weblink</Radio>
            }
          </Radio.Group>
        </Form.Item>

        {(isBulkCase ? routingModeBulk == "API" : routingMode == "API") ? (
          <>
            {lenderData?.products[0] === "Credit Card" &&
              <Form.Item
                    className="field-bg-border"
                    name="aggregator"
                    label="Select Aggregator"
                    rules={[{ required: true, message: "Please select Aggregator" }]}
                >
                <Select
                    showSearch
                    className="custom-select"
                    placeholder="Please select Aggregator"
                    optionFilterProp="children"
                    onChange={(value, option) => changeAggregatorHandler(value)}
                    filterOption={(input, option) =>
                      (option!.children as unknown as string)
                        ?.toLowerCase()
                        ?.includes(input?.toLowerCase())
                    }
                >
                  {aggregatorList?.map((item: any, i: number) => (
                    <Option key={i} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            }
            {(lenderData?.submissionType === "API" || selectedAggregator === "OneFlo (default)" || selectedAggregator === "oneflo") && 
            pIDetailList?.map((item) => {
              const fieldName = `${item.key}${isBulkCase?"_bulk":""}`;
              const initialValue = isBulkCase
                ? pIDetailInitialValuesForBulk?.find((detail: any) => detail.key === item.key)?.value
                : item.value;
              return (
                <Form.Item
                  className="field-bg-border"
                  name={fieldName}
                  label={item.key}
                  rules={[
                    { required: true, message: `Please enter ${item.key}` },
                  ]}
                  initialValue={initialValue}
                  key={fieldName}
                >
                  <Input
                    placeholder={`Enter ${item.key}`}
                    className="custom-input"
                  />
                </Form.Item>
              );
            })}
          </>
        ) : (
          <>
            <Form.Item
              className="field-bg-border"
              label="Hub"
              rules={[{ required: true, message: "Please enter hub" }]}
              name={`hub${isBulkCase?"_bulk":""}`}
            >
              <Select
                showSearch
                className="custom-select"
                placeholder="Hub"
                optionFilterProp="children"
                onChange={(value, option) => changeHubHandler(value, isBulkCase)}
                filterOption={(input, option) =>
                  (option!.children as unknown as string)
                    ?.toLowerCase()
                    ?.includes(input?.toLowerCase())
                }
              >
                {hubList?.map((item: any, i: number) => (
                  <Option key={i} value={item.hubName}>
                    {item.hubName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              className="field-bg-border"
              name={`pincode${isBulkCase?"_bulk":""}`}
              label="Pin Code"
            >
              <Input
                readOnly
                className="custom-input"
                defaultValue={lenderData?.pincode}
                placeholder="Please enter pincode"
              />
            </Form.Item>
            <Form.Item
              className="field-bg-border"
              name={`city${isBulkCase?"_bulk":""}`}
              label="City"
              rules={[{ required: true, message: "Please enter city" }]}
            >
              <Input placeholder="Please enter city" className="custom-input" />
            </Form.Item>

           {(isBulkCase ? routingModeBulk == "LOGIN" : routingMode == "LOGIN") && (
            <Form.Item
              className="field-bg-border"
              name={`lenderLoginUrl${isBulkCase?"_bulk":""}`}
              label="Lender Link"
              >
              <Input placeholder="Please enter Lender Link" className="custom-input" />
            </Form.Item>
           )}
          </>
        )}
    </>
  }


  const getProductPlanList = (loanProductCode) => {  
    API_SERVICE.getProductPlanList({
      pageSize: 100,
      loanProductId: loanProductCode,
      provider: lenderData?.lenderInfoId,
      productPlanStatus: "ACTIVE"
    })
      .then(({ data }) => {
        setProductPlan(data?.payload?.content ?? [])
        })
       
      
  };

  const getAggregators = (searchParam: any = null) => {
    const params = {
        pageNo: 1,
        pageSize: 1000,
        searchParam: searchParam,
        aggregatorConfigStatus:"ACTIVE"
    };
    API_SERVICE.getAggregators(params)
      .then((data) => {
        let tmpAggregatorList = data?.data?.payload?.content ?? []
        tmpAggregatorList.push({id:"oneflo", name:"OneFlo (default)"})
        setAggregatorList(tmpAggregatorList)
        })
      .catch((e: any) => API_SERVICE.handleErrors(e))
};

  const renderProductPlan = () => {
    return  (
    <Form.Item
    className="field-bg-border"
    style={{backgroundColor: editType == "PLAN" ? '#83838340' : "white"}}
    name="productPlanId"
    label="Product Plan"
    //rules={[{ required: editType != "PLAN", message: "Please select product plan" }]}
  >
    <Select
      showSearch
      className="custom-select"
      placeholder="Product Plan"
      optionFilterProp="children"
      // defaultValue={selectedProductPlan}
      disabled={editType == "PLAN"}
      filterOption={(input, option) =>
        (option!.children as unknown as string)
          ?.toLowerCase()
          ?.includes(input?.toLowerCase())
      }
    >
      {productPlan?.map((product: any, i: number) => (
        <Option key={i} value={product.productPlanId}>
          {product.productPlanName}
        </Option>
      ))}
    </Select>
  </Form.Item>
    )    
  }
  
  const renderOther = () => {
    return (
      <>
        {["PLAN", "PLAN_ADD"].includes(editType) ? renderProductPlan() : (
          <>
            <Form.Item
              className="field-bg-border"
              style={{backgroundColor:'#83838340'}}
              name="product"
              label="Product"
              rules={[{ required: true, message: "Please enter product name" }]}
            >
              <Select
                showSearch
                className="custom-select"
                placeholder="Product"
                optionFilterProp="children"
                disabled
                defaultValue={lenderData?.productId[0]}
                onChange={(value, option) => changeProductHandler(value)}
                filterOption={(input, option) => (option!.children as unknown as string)
                  ?.toLowerCase()
                  ?.includes(input?.toLowerCase())}
              >
                {products?.map((product: any, i: number) => (
                  <Option key={i} value={product.loanProductId}>
                    {product.loanProductName}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {lenderData?.products[0] === "Credit Card" && renderProductPlan()}

            <Radio.Group
              className="dynamic-radio"
              style={btnRadioStyles}
              name="consentType"
              value={consentType}
              onChange={(e) => {
                setConsentType(e?.target?.value);
                setConsentRequired(e?.target?.value != "Noconsent");
              } }
            >
                <Radio value="Noconsent">No Consent</Radio>
                <Radio value="GLOBAL">Global</Radio>
                <Radio value="INDIVIDUAL">Individual</Radio>
            </Radio.Group>
            <Form.Item
              name="individualCaseRouting"
              style={{ marginTop: "5px" }}
              label="Select Case Routing Mode"
            >
              <Checkbox
                defaultChecked={addLenderForm.getFieldValue("individualCaseRouting")}
                onChange={(e: any) => setIndividualCaseRouting(e?.target?.checked)}
              >
                Individual Case Routing
              </Checkbox>
            </Form.Item>
            {individualCaseRouting && renderIndividualCaseRouting(false)}
            <Form.Item 
                name="preferenceOrder"
                label="Preference Order"
                className="field-bg"
                rules={[
                 
                 {
                   validator: (_, value) => {
                     if (value === undefined || value === null) {
                       return Promise.resolve(); // Let 'required' rule handle emptiness
                     }
                     if (value >= 1 && value <= 5) {
                       return Promise.resolve();
                     }
                     return Promise.reject(new Error("Enter a number between 1 and 5"));
                   },
                 }
               ]}
             >
               <InputNumber 
                 className="custom-input-number" 
                 placeholder="Preference Order"
               />              
           </Form.Item>
            <Form.Item
              name="bulkCaseRouting"
              style={{ marginTop: "5px" }}
            >
              <Checkbox 
                defaultChecked={addLenderForm.getFieldValue("bulkCaseRouting")}
                onChange={(e: any) => setBulkCaseRouting(e?.target?.checked)}
                disabled={lenderData?.products[0] === "Credit Card"}
              >
                Bulk Case Routing
              </Checkbox>
            </Form.Item>
            {bulkCaseRouting && renderIndividualCaseRouting(true)}
            
          </>
        )}
        <Form.Item name="status" label="Status" style={{ color: "green" }}>
          <Switch 
            checked={status}
            style={{'--bgColor': appColors?.appPrimaryColor ?? ""} as any}
            onChange={(value) => setStatus(value)}
          />
        </Form.Item>

        <Form.Item style={{ marginTop: "50px" }}>
          <Space className="buttons">
            <Button
              className="dynamic-btn-primary"
              style={btnPrimaryStyles}
              size="large"
              //   loading={loading}
              type="primary"
              htmlType="submit"
            >
              Save
            </Button>
            <div></div>
          </Space>
        </Form.Item>
      </>
    );
  };

  return (
    <div className="content-box">
      <Form
        size="large"
        layout="vertical"
        form={addLenderForm}
        autoComplete="off"
        onFinish={addLender}
      >
        <Row gutter={[64, 16]}>
          <Col span={14}>
          <div style={{display:'flex', gap:'10px'}}>
            <Form.Item
              className="field-bg-border"
              style={{ backgroundColor:'#83838340', flex:'1' }}
              name="bankName"
              label="Lender Name"
              initialValue={lenderData?.lenderName}
            >
              <Text>{lenderData.lenderName}</Text>
            </Form.Item>
            {["PLAN", "PLAN_ADD"].includes(editType) && 
              <Form.Item
                className="field-bg-border"
                style={{ backgroundColor:'#83838340', flex:'1' }}
                name="product"
                label="Product"
              >
                <Text>{lenderData.products?.at(0)}</Text>
              </Form.Item>
            }
            </div>
            <Card className="Added-Product-List">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Title level={3}>{"Added Product Plans" }</Title>
                  
                </div>
                <Table
                    scroll={{ y: 300 }}
                    bordered={false}
                    pagination={false}
                    dataSource={lenderData?.products ?? []}
                    columns={columns}
                />
            </Card>
            {isViewPlan &&
              <Card className="Added-Product-List" style={{marginTop:'10px'}}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Title level={3}>{"Added Product Plan List" }</Title>
                  <Button
                  className="dynamic-btn-primary"
                  style={btnPrimaryStyles}
                  size="middle"
                  type="primary"
                  //hidden={isViewPlan}
                  onClick={() => {
                    setEditType("PLAN_ADD")
                    addLenderForm.resetFields();
                    setShowDSAIdView(true)
                    getProductPlanList(lenderData?.productId[0]);
                    // getPartnerIdentificationDetails( lenderData?.lenderInfoId,lenderData?.productId[0]);
                  }}
                >
                  Add
                </Button>
                </div>
                <Table
                    scroll={{ y: 300 }}
                    bordered={false}
                    pagination={false}
                    dataSource={viewLenderData}
                    columns={columnsPlan}
                />
              </Card>
            }
          </Col>
          <Col span={10}>{showDSAIdView ? renderOther() : null}</Col>
        </Row>
      </Form>
    </div>
  );
};

export default EditLender;
